import { render, staticRenderFns } from "./asset-detail.vue?vue&type=template&id=b51b2e90&scoped=true&"
import script from "./asset-detail.vue?vue&type=script&lang=js&"
export * from "./asset-detail.vue?vue&type=script&lang=js&"
import style0 from "./asset-detail.vue?vue&type=style&index=0&id=b51b2e90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51b2e90",
  null
  
)

export default component.exports